export default __webpack_public_path__ + "img/e3cbe2cd049df49bd1e0888eae6015f9.svg";